import { useCallback, useState } from 'react';
/**
For All Browser we are making the input readonly until the user focuses on it.
This is to prevent the browser from autofilling the input.
 */
export const useSuppressBrowserAutofill = () => {
  const [locked, setLocked] = useState(true);

  const unlockAutofill = useCallback(() => {
    setLocked(false);
  }, []);

  const relockAutofill = useCallback(() => {
    setLocked(true);
  }, []);

  return {
    autofillReadOnly: locked,
    unlockAutofill,
    relockAutofill,
  };
};
